import { translateLanguage } from 'components';
import {
  checkPhoneFeild,
  ignoreVal,
  isValidUSPhone,
  toCheckisUSPhone,
} from 'constants/phoneNoValidation';
import { AddRolodexContent,EditLeadDetailsContent, ViewClinicLocationContent } from 'models';
import { isValidPhoneNumber } from 'react-phone-number-input';
import * as Yup from 'yup';

export const phoneValidation = (isRequired?: 'req',message?:'message') => {
  if (isRequired === 'req' && isRequired !== undefined) {
    return Yup.string()
      .required(message === 'message' ?
      `${translateLanguage(`Rolodex.${[AddRolodexContent.workPhoneisrequired]}`)}`:
        translateLanguage(
          `EditLeadDetails.${[EditLeadDetailsContent.PhoneRequired]}`,
        ),
      )
      .test(
        'isValidPhoneNo',
        translateLanguage(
          `ClinicLocation.${[ViewClinicLocationContent.InvalidPhone]}`,
        ),
        (value: any) => {
          if (ignoreVal(value)) {
            return true;
          }
          return value !== undefined
            ? toCheckisUSPhone(value?.toString())
              ? isValidUSPhone(value?.toString())
              : isValidPhoneNumber(value?.toString())
            : true;
        },
      );
  }
  return Yup.string()
    .nullable()
    .test(
      'isValidPhoneNo',
      translateLanguage(
        `ClinicLocation.${[ViewClinicLocationContent.InvalidPhone]}`,
      ),
      (value: any) => {
        if (ignoreVal(value)) {
          return true;
        }
        return value !== undefined
          ? checkPhoneFeild(value)?.isFeildEmpty
            ? true
            : toCheckisUSPhone(value?.toString())
            ? isValidUSPhone(value?.toString())
            : isValidPhoneNumber(value?.toString())
          : true;
      },
    );
};
